export default __webpack_public_path__ + "static/media/goshen72.8bdcb844.jpg";